import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

export default class ZigZagSlider {
    constructor() {
        this.section = document.querySelectorAll('.components-block-zig-zag-slider');

        this.modal = document.querySelector('.modal-video');
        this.closeModal = this.modal.querySelector('.closeModal');
        this.videoLocal = this.modal.querySelector('#videoSection');
        this.legendaLocal = this.modal.querySelector('#legendaSection');

        this.ready();
    }

    ready() {
        this.section.forEach((section) => {
            const pictures = section.querySelectorAll('.picture-video');
            pictures.forEach((image) => {
                const videoUrl = image.dataset.video;
                const videoLegend = image.dataset.legenda;
                image.addEventListener('click', () => {
                    let iframe = document.createElement('iframe');

                    iframe.setAttribute('frameborder', '0');
                    iframe.setAttribute('allowfullscreen', '');
                    iframe.setAttribute(
                        'allow',
                        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                    );
                    // Important: add the autoplay GET parameter, otherwise the user would need to click over the YouTube video again to play it
                    iframe.setAttribute('src', videoUrl);

                    // Clear Thumbnail and load the YouTube iframe
                    this.videoLocal.innerHTML = '';
                    this.videoLocal.appendChild(iframe);
                    this.legendaLocal.innerHTML = videoLegend;

                    this.modal.classList.add('active');

                    this.closeModal.addEventListener('click', () => {
                        this.modal.classList.remove('active');
                        this.videoLocal.innerHTML = '';
                    });
                });
            });

            // Inicializa o swiper
            let slider = section.querySelector('.swiper');
            let navigationPrev = section.querySelector('.slider-button-prev');
            let navigationNext = section.querySelector('.slider-button-next');

            new Swiper(slider, {
                modules: [Navigation, Pagination, Autoplay],
                grabCursor: true,
                slidesPerView: 1,
                spaceBetween: '56px',
                allowTouchMove: true,
                autoplay: {
                    delay: 3000,
                },
                navigation: {
                    nextEl: navigationNext,
                    prevEl: navigationPrev,
                },
            });
        });
    }
}

if (document.querySelector('.components-block-zig-zag-slider')) {
    new ZigZagSlider();
}
